import { allCountries, Country, iso2Lookup } from 'country-telephone-data'

function countryData(country: Country) {
  return {
    prefixCountry: country.iso2.toUpperCase(),
    phonePrefix: country.dialCode,
  }
}

function ensureNumericPrefix(prefix: string): string {
  if (!prefix || typeof prefix === 'string') {
    return prefix.replace(/^\++/g, '')
  } else {
    console.warn(`getPrefixCountry:ensureNumericPrefix:prefix is invalid: ${prefix}`)
    return ''
  }
}

export function getPrefixCountry(currentCountryCode: string = '', phonePrefix: string = '') {
  const numericPrefix = phonePrefix && ensureNumericPrefix(phonePrefix)

  // If user's current region matches prefix, return that
  // @ts-expect-error `isoLookup` is wrongly typed. It's Record<string, number>
  const userCountry = allCountries[iso2Lookup[currentCountryCode.toLowerCase()]]
  if (userCountry && userCountry.dialCode == numericPrefix) {
    return countryData(userCountry)
  }

  // Otherwise, look up country based on prefix
  const countryForPrefix = allCountries.find(
    country => country.dialCode == numericPrefix && !country.priority)
  if (countryForPrefix) {
    return countryData(countryForPrefix)
  }

  // If prefix is invalid, return data for user's country
  if (userCountry) {
    return countryData(userCountry)
  }

  // If all else fails, return AU
  // @ts-expect-error `isoLookup` is wrongly typed. It's Record<string, number>
  return countryData(allCountries[iso2Lookup.au])
}
